export const SUPPORTED_LANGS = ['zh', 'en', 'ja', 'kr', 'tr', 'ru'];
export const DEFAULT_LANG = 'en';

const LANG_ALIASES = {
  'zh-cn': 'zh',
  'zh-tw': 'zh',
  cn: 'zh',
  'en-us': 'en',
  'en-gb': 'en',
  en_us: 'en',
  ja_jp: 'ja',
  jp: 'ja',
  'ja-jp': 'ja',
  ko: 'kr',
  'ko-kr': 'kr',
  kr_kr: 'kr',
  'tr-tr': 'tr',
  tur: 'tr',
  turkish: 'tr',
  'ru-ru': 'ru',
  rus: 'ru',
  russian: 'ru'
};

export function normalizeLang(lang) {
  const value = String(lang || '').trim().toLowerCase();
  const normalized = LANG_ALIASES[value] || value;
  return SUPPORTED_LANGS.includes(normalized) ? normalized : DEFAULT_LANG;
}

export function getLang() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_LANG;
  }
  return normalizeLang(window.localStorage.getItem('lang'));
}

export function setLang(lang) {
  const normalized = normalizeLang(lang);
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem('lang', normalized);
  }
  setDocumentLang(normalized);
  return normalized;
}

export function setDocumentLang(lang) {
  const normalized = normalizeLang(lang);
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = normalized === 'kr' ? 'ko' : normalized;
  }
}

export function pickLocalizedSegment(value, lang = getLang(), order = SUPPORTED_LANGS, separator = '|') {
  if (value === null || value === undefined) {
    return '';
  }

  const segments = Array.isArray(value)
    ? value
    : String(value).split(separator);
  const normalizedOrder = order.map(normalizeLang);
  const requestedIndex = normalizedOrder.indexOf(normalizeLang(lang));
  const englishIndex = normalizedOrder.indexOf(DEFAULT_LANG);
  const index = requestedIndex >= 0 ? requestedIndex : englishIndex;

  return String(
    segments[index] !== undefined && segments[index] !== ''
      ? segments[index]
      : (segments[englishIndex] || segments[0] || '')
  ).trim();
}
